<template>
  <div class="members layout-spacing" data-locator="participants-page">
    <MembersHeader v-model:searchQuery="searchQuery"
                   :mnemo="roomMnemo"
                   @onAddGroup="openAddGroupDialog"
    />

    <template v-if="loading || groups.length === 0">
      <v-row>
        <v-col v-for="_ in 4" :key="_" cols="3">
          <v-skeleton-loader type="text, heading@2"/>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col v-for="group in filteredGroups"
               :key="`group-${group.id}`"
               cols="12"
               sm="6"
               md="4"
               lg="3"
               xl="2"
        >
          <Group :group="group" :mnemo="roomMnemo"/>
        </v-col>
        <v-col v-if="isPm"
               cols="12"
               sm="6"
               md="4"
               lg="3"
               xl="2"
        >
          <v-btn variant="flat"
                 color="surface-tertiary"
                 class="add-group-box text-text-tertiary"
                 :min-height="$vuetify.display.xs ? '80px' : '200px'"
                 data-locator="add-group-secondary-button"
                 @click="openAddGroupDialog"
          >
            <app-material-icon name="add_circle" class="mr-2" />
            {{ $t('project.members.Members.addGroup') }}
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <MembersAddGroupDialog v-if="addGroupDialogIsOpen" @close="closeAddGroupDialog" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { mapActions, mapGetters, mapState } from 'vuex'

import MembersAddGroupDialog from './dialogs/MembersAddGroupDialog.vue'
import Group from './Group.vue'
import MembersHeader from './MembersHeader.vue'

export default {
  name: 'Members',
  components: {
    Group,
    MembersAddGroupDialog,
    MembersHeader,
  },
  data () {
    return {
      addGroupDialogIsOpen: false,
      hideMembersDialogIsOpen: false,
      searchQuery: '',
    }
  },
  head () {
    return {
      title: this.$t('project.members.Members.metaTitle'),
    }
  },
  computed: {
    ...mapState('groups', ['groups', 'loading']),
    ...mapGetters('room', ['roomMnemo']),
    isPm () {
      return this.$store.getters['room/isCurrentUserPm']
    },
    filteredGroups () {
      const filteredGroups = cloneDeep(this.groups)

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase()
        filteredGroups.forEach(group => {
          group.members = group.members.filter(member =>
            member.fullName.toLowerCase().includes(query) ||
            member.company.toLowerCase().includes(query))
        })
      }
      return filteredGroups
    },
  },
  mounted () {
    this.GET_GROUPS(this.roomMnemo)
  },
  methods: {
    ...mapActions('groups', ['GET_GROUPS']),
    openAddGroupDialog () {
      this.addGroupDialogIsOpen = true
    },
    closeAddGroupDialog () {
      this.addGroupDialogIsOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/border-tokens";
@import "@/scss/typography-tokens";

.add-group-box {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: get-border();
  border-radius: get-radius('border-radius-3');
  // Applied here rather than with a class: `.v-btn` sets its own font-size and
  // font-weight, which a template utility class of equal specificity would not
  // reliably beat.
  @include text('body-md-bold');

  &:hover {
    border-color: rgb(var(--v-theme-border-secondary-hover));
  }
}
</style>
